/* eslint-disable eqeqeq */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Heading,
  Flex,
  Checkbox,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import {
  useLookupPermissions,
  useLookupResources,
} from "../../services/lookups-queries";
import FormInput from "../../components/forms/form-Input";
import { useGetRole, useGetUsersList } from "../../services/auth-api";
import { formDefaultValues } from "./constants";
import ReactHookFormDropdown from "components/forms/react-hook-dropdown";
import { Textarea } from "@repo/ui";

export default function RoleDetails() {
  const params = useParams();

  const {
    mutate: getRole,
    isSuccess: isRoleAvailable,
    data: roleDetails,
    isPending: gettingRole,
    reset: resetRoleDetails,
  } = useGetRole();

  const { data: employees, mutate: getUsersList } = useGetUsersList();
  const { data: resourcesRes, isPending: gettingResources } =
    useLookupResources();
  const { data: rolePermissionRes, isPending: gettingRolePermission } =
    useLookupPermissions();
  const {
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { ...formDefaultValues },
  });

  const generalFieldProps = { errors, control };
  const { fields: permissionsFields } = useFieldArray({
    control: generalFieldProps.control,
    name: "permissions",
  });

  useEffect(() => {
    getUsersList();
    if (params.roleName) {
      const name = params.roleName.split("_").join(" ");
      getRole(name);
    }
  }, []);

  useEffect(() => {
    if (isRoleAvailable && resourcesRes && rolePermissionRes) {
      reset({
        roleName: roleDetails.data.name,
        description: roleDetails.data.description,
        permissions: roleDetails.data.permissions.map((elm) => ({
          resource: elm.resourceKey,
          permission: elm.permissionKey,
        })),
      });
      resetRoleDetails();
    }
  }, [isRoleAvailable, rolePermissionRes, resourcesRes]);

  return (
    <>
      {gettingRolePermission || gettingResources || gettingRole ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Roles", link: Paths.roles },
            {
              text: "Role Details",
              isCurrentPage: true,
            },
          ]}
        />

        <Card flexDirection="column" w="100%">
          <CardBody>
            <Flex w="100%" justify="space-between" flexDirection="row">
              <Heading>{watch("roleName")}</Heading>
              <Button
                as={Link}
                to={`${Paths.editRole}/${watch("roleName")?.split(" ").join("_")}`}
              >
                Edit
              </Button>
            </Flex>
            <div>
              <form className="add-location-form">
                <FormInput
                  {...generalFieldProps}
                  label="Role Name"
                  name="roleName"
                  readOnly
                />
                <FormInput
                  {...generalFieldProps}
                  label="Description"
                  name="description"
                  readOnly
                />{" "}
                <FormInput
                  {...generalFieldProps}
                  label="Requested By"
                  name="requestedBy"
                  readOnly
                />
                <div className="full-width-field">
                  {" "}
                  <FormControl>
                    <FormLabel>Comments</FormLabel>
                    <Controller
                      control={control}
                      name="comments"
                      render={({ field }) => (
                        <Textarea readOnly disabled value={field.value} />
                      )}
                    />
                  </FormControl>
                </div>
                <table className="roles-perm-table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "start" }}>Role</th>
                      <th>Select All</th>
                      {rolePermissionRes?.data.map((perm, index) => (
                        <th width="100px" key={index}>
                          {perm.text}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {resourcesRes?.data.map((role, index) => (
                      <tr key={index}>
                        <td style={{ fontWeight: "bold" }}>{role.text}</td>
                        <td>
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            title={`${role.text}`}
                          >
                            <Checkbox
                              disabled
                              isChecked={
                                permissionsFields.filter(
                                  (elm) => elm.resource == role.value,
                                ).length == rolePermissionRes?.data.length
                              }
                            />
                          </div>
                        </td>
                        {rolePermissionRes?.data.map((perm, index) => (
                          <td key={index}>
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              title={`${perm.text}-${role.text}`}
                            >
                              <Checkbox
                                disabled
                                isChecked={
                                  permissionsFields.findIndex(
                                    (elm) =>
                                      elm.resource == role.value &&
                                      elm.permission == perm.value,
                                  ) !== -1
                                }
                              />
                            </div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </form>
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
}
